// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: rtc/device_location_history.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Point } from "../geo/geo";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "carbon.rtc";

export enum DeviceType {
  DEVICE_TYPE_UNKNOWN = 0,
  IRIDIUM_EDGE = 1,
  PEPLINK_GENERIC = 2,
  PARTICLE = 3,
  UNRECOGNIZED = -1,
}

export function deviceTypeFromJSON(object: any): DeviceType {
  switch (object) {
    case 0:
    case "DEVICE_TYPE_UNKNOWN":
      return DeviceType.DEVICE_TYPE_UNKNOWN;
    case 1:
    case "IRIDIUM_EDGE":
      return DeviceType.IRIDIUM_EDGE;
    case 2:
    case "PEPLINK_GENERIC":
      return DeviceType.PEPLINK_GENERIC;
    case 3:
    case "PARTICLE":
      return DeviceType.PARTICLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DeviceType.UNRECOGNIZED;
  }
}

export function deviceTypeToJSON(object: DeviceType): string {
  switch (object) {
    case DeviceType.DEVICE_TYPE_UNKNOWN:
      return "DEVICE_TYPE_UNKNOWN";
    case DeviceType.IRIDIUM_EDGE:
      return "IRIDIUM_EDGE";
    case DeviceType.PEPLINK_GENERIC:
      return "PEPLINK_GENERIC";
    case DeviceType.PARTICLE:
      return "PARTICLE";
    case DeviceType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface DeviceLocationHistoryRecord {
  point: Point | undefined;
  timestamp: string | undefined;
  deviceId: string;
  deviceType: DeviceType;
}

export interface DeviceLocationHistoryRecordList {
  records: DeviceLocationHistoryRecord[];
}

export interface LogDeviceLocationHistoryRequest {
  history: DeviceLocationHistoryRecordList | undefined;
}

export interface ListDevicesRequest {
  pageSize: number;
  pageToken: string;
  /** If not empty, only list devices with the given device_ids. */
  deviceIds: string[];
}

export interface ListDevicesResponse {
  nextPageToken: string;
  devices: DeviceSummary[];
}

export interface DeviceSummary {
  id: string;
  lastSeen: DeviceLocationHistoryRecord | undefined;
}

export interface ListDeviceLocationHistoryRequest {
  pageSize: number;
  pageToken: string;
  deviceId: string;
  start: string | undefined;
  end: string | undefined;
  desc: boolean;
  includeClosest: boolean;
}

export interface ListDeviceLocationHistoryResponse {
  nextPageToken: string;
  history: DeviceLocationHistoryRecordList | undefined;
}

function createBaseDeviceLocationHistoryRecord(): DeviceLocationHistoryRecord {
  return { point: undefined, timestamp: undefined, deviceId: "", deviceType: 0 };
}

export const DeviceLocationHistoryRecord: MessageFns<DeviceLocationHistoryRecord> = {
  encode(message: DeviceLocationHistoryRecord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.point !== undefined) {
      Point.encode(message.point, writer.uint32(10).fork()).join();
    }
    if (message.timestamp !== undefined) {
      Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).join();
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.deviceType !== 0) {
      writer.uint32(32).int32(message.deviceType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceLocationHistoryRecord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceLocationHistoryRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.point = Point.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.deviceType = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceLocationHistoryRecord {
    return {
      point: isSet(object.point) ? Point.fromJSON(object.point) : undefined,
      timestamp: isSet(object.timestamp) ? globalThis.String(object.timestamp) : undefined,
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
        ? globalThis.String(object.device_id)
        : "",
      deviceType: isSet(object.deviceType)
        ? deviceTypeFromJSON(object.deviceType)
        : isSet(object.device_type)
        ? deviceTypeFromJSON(object.device_type)
        : 0,
    };
  },

  toJSON(message: DeviceLocationHistoryRecord): unknown {
    const obj: any = {};
    if (message.point !== undefined) {
      obj.point = Point.toJSON(message.point);
    }
    if (message.timestamp !== undefined) {
      obj.timestamp = message.timestamp;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceType !== 0) {
      obj.deviceType = deviceTypeToJSON(message.deviceType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceLocationHistoryRecord>, I>>(base?: I): DeviceLocationHistoryRecord {
    return DeviceLocationHistoryRecord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceLocationHistoryRecord>, I>>(object: I): DeviceLocationHistoryRecord {
    const message = createBaseDeviceLocationHistoryRecord();
    message.point = (object.point !== undefined && object.point !== null) ? Point.fromPartial(object.point) : undefined;
    message.timestamp = object.timestamp ?? undefined;
    message.deviceId = object.deviceId ?? "";
    message.deviceType = object.deviceType ?? 0;
    return message;
  },
};

function createBaseDeviceLocationHistoryRecordList(): DeviceLocationHistoryRecordList {
  return { records: [] };
}

export const DeviceLocationHistoryRecordList: MessageFns<DeviceLocationHistoryRecordList> = {
  encode(message: DeviceLocationHistoryRecordList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.records) {
      DeviceLocationHistoryRecord.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceLocationHistoryRecordList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceLocationHistoryRecordList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.records.push(DeviceLocationHistoryRecord.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceLocationHistoryRecordList {
    return {
      records: globalThis.Array.isArray(object?.records)
        ? object.records.map((e: any) => DeviceLocationHistoryRecord.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DeviceLocationHistoryRecordList): unknown {
    const obj: any = {};
    if (message.records?.length) {
      obj.records = message.records.map((e) => DeviceLocationHistoryRecord.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceLocationHistoryRecordList>, I>>(base?: I): DeviceLocationHistoryRecordList {
    return DeviceLocationHistoryRecordList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceLocationHistoryRecordList>, I>>(
    object: I,
  ): DeviceLocationHistoryRecordList {
    const message = createBaseDeviceLocationHistoryRecordList();
    message.records = object.records?.map((e) => DeviceLocationHistoryRecord.fromPartial(e)) || [];
    return message;
  },
};

function createBaseLogDeviceLocationHistoryRequest(): LogDeviceLocationHistoryRequest {
  return { history: undefined };
}

export const LogDeviceLocationHistoryRequest: MessageFns<LogDeviceLocationHistoryRequest> = {
  encode(message: LogDeviceLocationHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.history !== undefined) {
      DeviceLocationHistoryRecordList.encode(message.history, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): LogDeviceLocationHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLogDeviceLocationHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.history = DeviceLocationHistoryRecordList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): LogDeviceLocationHistoryRequest {
    return { history: isSet(object.history) ? DeviceLocationHistoryRecordList.fromJSON(object.history) : undefined };
  },

  toJSON(message: LogDeviceLocationHistoryRequest): unknown {
    const obj: any = {};
    if (message.history !== undefined) {
      obj.history = DeviceLocationHistoryRecordList.toJSON(message.history);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<LogDeviceLocationHistoryRequest>, I>>(base?: I): LogDeviceLocationHistoryRequest {
    return LogDeviceLocationHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<LogDeviceLocationHistoryRequest>, I>>(
    object: I,
  ): LogDeviceLocationHistoryRequest {
    const message = createBaseLogDeviceLocationHistoryRequest();
    message.history = (object.history !== undefined && object.history !== null)
      ? DeviceLocationHistoryRecordList.fromPartial(object.history)
      : undefined;
    return message;
  },
};

function createBaseListDevicesRequest(): ListDevicesRequest {
  return { pageSize: 0, pageToken: "", deviceIds: [] };
}

export const ListDevicesRequest: MessageFns<ListDevicesRequest> = {
  encode(message: ListDevicesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(18).string(message.pageToken);
    }
    for (const v of message.deviceIds) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListDevicesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDevicesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDevicesRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      deviceIds: globalThis.Array.isArray(object?.deviceIds)
        ? object.deviceIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.device_ids)
        ? object.device_ids.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: ListDevicesRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.deviceIds?.length) {
      obj.deviceIds = message.deviceIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDevicesRequest>, I>>(base?: I): ListDevicesRequest {
    return ListDevicesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDevicesRequest>, I>>(object: I): ListDevicesRequest {
    const message = createBaseListDevicesRequest();
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.deviceIds = object.deviceIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseListDevicesResponse(): ListDevicesResponse {
  return { nextPageToken: "", devices: [] };
}

export const ListDevicesResponse: MessageFns<ListDevicesResponse> = {
  encode(message: ListDevicesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextPageToken !== "") {
      writer.uint32(10).string(message.nextPageToken);
    }
    for (const v of message.devices) {
      DeviceSummary.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListDevicesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDevicesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.devices.push(DeviceSummary.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDevicesResponse {
    return {
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      devices: globalThis.Array.isArray(object?.devices)
        ? object.devices.map((e: any) => DeviceSummary.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ListDevicesResponse): unknown {
    const obj: any = {};
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.devices?.length) {
      obj.devices = message.devices.map((e) => DeviceSummary.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDevicesResponse>, I>>(base?: I): ListDevicesResponse {
    return ListDevicesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDevicesResponse>, I>>(object: I): ListDevicesResponse {
    const message = createBaseListDevicesResponse();
    message.nextPageToken = object.nextPageToken ?? "";
    message.devices = object.devices?.map((e) => DeviceSummary.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeviceSummary(): DeviceSummary {
  return { id: "", lastSeen: undefined };
}

export const DeviceSummary: MessageFns<DeviceSummary> = {
  encode(message: DeviceSummary, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.lastSeen !== undefined) {
      DeviceLocationHistoryRecord.encode(message.lastSeen, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeviceSummary {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeviceSummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.lastSeen = DeviceLocationHistoryRecord.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeviceSummary {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      lastSeen: isSet(object.lastSeen)
        ? DeviceLocationHistoryRecord.fromJSON(object.lastSeen)
        : isSet(object.last_seen)
        ? DeviceLocationHistoryRecord.fromJSON(object.last_seen)
        : undefined,
    };
  },

  toJSON(message: DeviceSummary): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.lastSeen !== undefined) {
      obj.lastSeen = DeviceLocationHistoryRecord.toJSON(message.lastSeen);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeviceSummary>, I>>(base?: I): DeviceSummary {
    return DeviceSummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeviceSummary>, I>>(object: I): DeviceSummary {
    const message = createBaseDeviceSummary();
    message.id = object.id ?? "";
    message.lastSeen = (object.lastSeen !== undefined && object.lastSeen !== null)
      ? DeviceLocationHistoryRecord.fromPartial(object.lastSeen)
      : undefined;
    return message;
  },
};

function createBaseListDeviceLocationHistoryRequest(): ListDeviceLocationHistoryRequest {
  return {
    pageSize: 0,
    pageToken: "",
    deviceId: "",
    start: undefined,
    end: undefined,
    desc: false,
    includeClosest: false,
  };
}

export const ListDeviceLocationHistoryRequest: MessageFns<ListDeviceLocationHistoryRequest> = {
  encode(message: ListDeviceLocationHistoryRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== 0) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== "") {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.deviceId !== "") {
      writer.uint32(26).string(message.deviceId);
    }
    if (message.start !== undefined) {
      Timestamp.encode(toTimestamp(message.start), writer.uint32(34).fork()).join();
    }
    if (message.end !== undefined) {
      Timestamp.encode(toTimestamp(message.end), writer.uint32(42).fork()).join();
    }
    if (message.desc !== false) {
      writer.uint32(48).bool(message.desc);
    }
    if (message.includeClosest !== false) {
      writer.uint32(56).bool(message.includeClosest);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListDeviceLocationHistoryRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDeviceLocationHistoryRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.start = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.end = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.desc = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.includeClosest = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDeviceLocationHistoryRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : 0,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : "",
      deviceId: isSet(object.deviceId)
        ? globalThis.String(object.deviceId)
        : isSet(object.device_id)
        ? globalThis.String(object.device_id)
        : "",
      start: isSet(object.start) ? globalThis.String(object.start) : undefined,
      end: isSet(object.end) ? globalThis.String(object.end) : undefined,
      desc: isSet(object.desc) ? globalThis.Boolean(object.desc) : false,
      includeClosest: isSet(object.includeClosest)
        ? globalThis.Boolean(object.includeClosest)
        : isSet(object.include_closest)
        ? globalThis.Boolean(object.include_closest)
        : false,
    };
  },

  toJSON(message: ListDeviceLocationHistoryRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== "") {
      obj.pageToken = message.pageToken;
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.start !== undefined) {
      obj.start = message.start;
    }
    if (message.end !== undefined) {
      obj.end = message.end;
    }
    if (message.desc !== false) {
      obj.desc = message.desc;
    }
    if (message.includeClosest !== false) {
      obj.includeClosest = message.includeClosest;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDeviceLocationHistoryRequest>, I>>(
    base?: I,
  ): ListDeviceLocationHistoryRequest {
    return ListDeviceLocationHistoryRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDeviceLocationHistoryRequest>, I>>(
    object: I,
  ): ListDeviceLocationHistoryRequest {
    const message = createBaseListDeviceLocationHistoryRequest();
    message.pageSize = object.pageSize ?? 0;
    message.pageToken = object.pageToken ?? "";
    message.deviceId = object.deviceId ?? "";
    message.start = object.start ?? undefined;
    message.end = object.end ?? undefined;
    message.desc = object.desc ?? false;
    message.includeClosest = object.includeClosest ?? false;
    return message;
  },
};

function createBaseListDeviceLocationHistoryResponse(): ListDeviceLocationHistoryResponse {
  return { nextPageToken: "", history: undefined };
}

export const ListDeviceLocationHistoryResponse: MessageFns<ListDeviceLocationHistoryResponse> = {
  encode(message: ListDeviceLocationHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.nextPageToken !== "") {
      writer.uint32(10).string(message.nextPageToken);
    }
    if (message.history !== undefined) {
      DeviceLocationHistoryRecordList.encode(message.history, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListDeviceLocationHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListDeviceLocationHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.history = DeviceLocationHistoryRecordList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListDeviceLocationHistoryResponse {
    return {
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : "",
      history: isSet(object.history) ? DeviceLocationHistoryRecordList.fromJSON(object.history) : undefined,
    };
  },

  toJSON(message: ListDeviceLocationHistoryResponse): unknown {
    const obj: any = {};
    if (message.nextPageToken !== "") {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.history !== undefined) {
      obj.history = DeviceLocationHistoryRecordList.toJSON(message.history);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListDeviceLocationHistoryResponse>, I>>(
    base?: I,
  ): ListDeviceLocationHistoryResponse {
    return ListDeviceLocationHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListDeviceLocationHistoryResponse>, I>>(
    object: I,
  ): ListDeviceLocationHistoryResponse {
    const message = createBaseListDeviceLocationHistoryResponse();
    message.nextPageToken = object.nextPageToken ?? "";
    message.history = (object.history !== undefined && object.history !== null)
      ? DeviceLocationHistoryRecordList.fromPartial(object.history)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(dateStr: string): Timestamp {
  const date = new globalThis.Date(dateStr);
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): string {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis).toISOString();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
